import { cloneDeep } from 'lodash';
const SET_ACTIVE_FILTER = 'SET_ACTIVE_FILTER';
import {setActiveFilterResult} from './active_filter_result';
import { getSortedProducts } from './sort';

const initialState = '';

export default function reducer(state = cloneDeep(initialState), action) {
	switch (action.type) {
		case SET_ACTIVE_FILTER:
			return action.payload;
		default:
			return state;
	}
}

export function setActiveFilter( filter ){
	return{
		type: SET_ACTIVE_FILTER,
		payload: filter
	}
}

export function constructActiveFilter() {
    let sActiveFilter   = '';
    let oActiveResult   = {};
    return (dispatch, getState) => {
	    // no active category or result if path isn't '/catalog'
	    if (getState().path !== '/catalog' && getState().path !== '/') {
	      return dispatch([
	       	setActiveFilter( sActiveFilter ),
	        setActiveFilterResult( oActiveResult),
	        getSortedProducts()
	      ]);
	    }
	   	if (!getState().urlParams[0]) {
	      sActiveFilter = 'category';
	      oActiveResult = [...(getState().maps).get('categoryMap').values()][0];

	    // otherwise, calculate filter + result based on urlParams
	    } /* GIFTSHOP else if( getState().urlParams[0] === 'giftshop' && getState().urlParams.length === 2){
	    	sActiveFilter = 'giftshop'
	      oActiveResult = getState().maps.get('genreMap').get(parseInt(getState().urlParams[1], 10)) || {};
	    } else if( getState().urlParams[0] === 'giftshop'){
	    	sActiveFilter = 'giftshop'
	      oActiveResult = getState().maps.get('genreMap').get(getState().store.giftShop[0]) || {};
	    } */ else if ( getState().urlParams && getState().urlParams.length === 2) {
	      sActiveFilter = getState().urlParams[0];
	      oActiveResult = getState().maps.get(getState().urlParams[0] + 'Map').get(parseInt(getState().urlParams[1], 10)) || {};
	    }

	    return dispatch([
	     	setActiveFilter( sActiveFilter ),
	      setActiveFilterResult( oActiveResult),
	      getSortedProducts()
	    ]);
  	}
  }


// WEBPACK FOOTER //
// ./src/modules/active_filter.js